import { Reveal, SectionHead } from "./shared";
import { SAGA_BOOKS } from "@/lib/site";

export default function Saga() {
  return (
    <section id="saga" className="relative bg-lake-deep py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          kicker="La Saga"
          title="Una storia più grande di un solo libro"
          sub="Il Segreto del Lago è il primo romanzo di una saga in evoluzione. Il secondo volume è già in scrittura."
        />

        <div className="relative mt-16 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="absolute left-1/2 top-0 hidden h-full w-px bg-gradient-to-b from-gold/50 via-gold/15 to-transparent lg:block" />
          {SAGA_BOOKS.map((b, i) => (
            <Reveal key={b.volume} delay={i * 0.15}>
              <article
                data-testid={`saga-book-${i + 1}`}
                className={`relative rounded-xl border p-8 ${
                  b.active
                    ? "border-gold/40 bg-lake-teal/40 shadow-[0_0_35px_rgba(197,155,39,0.12)]"
                    : "border-dashed border-parchment-ivory/20 bg-lake-teal/15"
                }`}
              >
                <div className="flex items-center justify-between gap-4">
                  <p className="text-xs uppercase tracking-[0.3em] text-gold">{b.volume}</p>
                  <span
                    className={`rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-wider ${
                      b.active
                        ? "bg-gold text-ink-dark"
                        : "border border-parchment-ivory/30 text-parchment-ivory/60"
                    }`}
                  >
                    {b.status}
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-2xl text-parchment-ivory sm:text-3xl">{b.title}</h3>
                <p className="mt-2 text-sm font-medium text-gold-shimmer">{b.release}</p>
                <p className="mt-4 text-sm leading-relaxed text-parchment-ivory/65">{b.synopsis}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
